import { create as l } from "zustand";
import { produce as c } from "immer";
import { devtools as d } from "zustand/middleware";
const S = l()(
  d(
    (t, r) => ({
      selectedLocations: [],
      multiEditMode: !1,
      actions: {
        setSelectedLocation: (e) => {
          const o = e == null ? void 0 : e.selectedLocation, i = e == null ? void 0 : e.selectedLocationGenerator;
          t(
            c((n) => ({
              ...n,
              selectedLocation: o,
              selectedLocationGenerator: i
            }))
          );
        },
        setSelectedLocationGenerator: (e) => {
          t(
            c((o) => ({
              ...o,
              selectedLocationGenerator: e
            }))
          );
        },
        setPINCoord: (e) => {
          t(
            c((o) => ({
              ...o,
              selectedPINCoord: e
            }))
          );
        },
        setMultiEditMode: (e) => {
          t(
            c((o) => ({
              ...o,
              multiEditMode: e
            }))
          );
        },
        setActiveSearchLoadingBar: (e) => {
          t(
            c((o) => ({
              ...o,
              activeSearchLoadingBar: e
            }))
          );
        },
        addSelectedLocation: (e) => {
          t(
            c((o) => ({
              selectedLocations: [...o.selectedLocations, e]
            }))
          );
        },
        removeSelectedLocation: (e) => {
          t(
            c((o) => ({
              selectedLocations: o.selectedLocations.filter(
                (i) => i.id !== e
              )
            }))
          );
        },
        updateSelectedLocation: (e, o) => {
          t(
            c((i) => ({
              selectedLocations: i.selectedLocations.map(
                (n) => n.id === e ? { ...n, ...o } : n
              )
            }))
          );
        },
        clearSelectedLocations: () => {
          t(
            c((e) => ({
              selectedLocations: []
            }))
          );
        },
        setExistingFillColor: (e) => {
          t(
            c((o) => ({
              ...o,
              existingFillColor: e
            }))
          );
        },
        setOnAddLocationToTag: (e) => {
          t(
            c((o) => ({
              ...o,
              onAddLocationToTag: e
            }))
          );
        }
      }
    }),
    {
      name: "MapSearchStore",
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__)
    }
  )
);
export {
  S as useAddLocationStore
};
//# sourceMappingURL=index.es36.js.map
